import { forwardRef } from "react";
import { FormControl, FormErrorMessage, Textarea } from "@chakra-ui/react";
import { getObjValueFromPath } from "utils";
import EsgFormLabel from "./EsgFormLabel";

function FormTextArea(
  { label, name, id = name, errors, controlProps, ...rest },
  ref
) {
  const error = getObjValueFromPath(name, errors);
  return (
    <FormControl
      isInvalid={error}
      minInlineSize="0"
      {...controlProps}
    >
      {label && (
        <EsgFormLabel
          htmlFor={id}
        >
          {label}
        </EsgFormLabel>
      )}
      <Textarea
        backgroundColor="white"
        borderRadius="none"
        marginBlockStart={1}
        blockSize="36"
        size="md"
        resize="none"
        id={id}
        name={name}
        ref={ref}
        {...rest}
      />
      {error && <FormErrorMessage>{error?.message}</FormErrorMessage>}
    </FormControl>
  );
}

export default forwardRef(FormTextArea);
